import React, {useEffect} from "react";
import {useLocation} from "../../../common/common";
import {usePagesRest} from "../../../hooks/usePages";
import ViewNoContainer from "../ViewNoContainer";
import * as ROUTES from "../../../common/routes";
import HtmlComponentWrapper from "../../widget/compose/HtmlComponentWrapper";
import * as PropTypes from "prop-types";
import {SEO as Seo} from "@hapinest/theme";
import {Box} from "@material-ui/core";
import {Helmet} from "react-helmet";

export const ComposeViewWrapper = ({slug}) => {

    const {seoData, pageTitle, htmlComponents, pageLoading, pageError} = usePagesRest(slug);

    const {navigate} = useLocation();

    let content;

    useEffect(() => {
        if (!pageLoading && !htmlComponents && pageError) {
            navigate(ROUTES.ERROR_PAGE_404);
        }
    }, [htmlComponents, pageLoading, pageError]);

    if (!pageLoading) {
        if (htmlComponents) {
            content = (
                <HtmlComponentWrapper
                    htmlComponents={htmlComponents}
                    pageSlug={slug}
                />
            );
        }
    }

    return (
        <ViewNoContainer withMargin={false}>
            {slug?.includes("404") &&
                <Helmet>
                    <meta
                        name="prerender-status-code"
                        content="404"
                    />
                </Helmet>
            }
            <Seo
                title={pageLoading ? "" : seoData?.title ? seoData?.title : pageTitle ? pageTitle : "Hapimag"}
                description={!pageLoading && seoData?.description ? seoData?.description : undefined}
                image={seoData?.image?.fields?.file?.url}
            />
            <Box pb={5}>
                {content}
            </Box>
        </ViewNoContainer>
    );
};

ComposeViewWrapper.propTypes = {
    slug: PropTypes.string,
};

export default ComposeViewWrapper;
